// CSS Style
import 'sweetalert2/dist/sweetalert2.css';
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.min.css';
import 'aos/dist/aos.css';
import 'styles/client'

import Rails from "@rails/ujs"
import AOS from 'aos';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import Swiper, { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper';
import 'client/base';
import 'client/header_footer';
import 'client/home';
import 'client/treatment';
import 'client/doctors';

Rails.start();


window.jQuery = $;
window.$ = $;
window.Swal = Swal;
window.AOS = AOS;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;
